import { render } from "./Medicine.vue?vue&type=template&id=f1d92a50&scoped=true"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"

import "./Medicine.vue?vue&type=style&index=0&id=f1d92a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d92a50"]])

export default __exports__